import axios from "axios";
import { Toast } from "vant";
import store from "@/store";

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 30000
});

axiosInstance.interceptors.request.use(config => {
  config.headers.mac = store.state.mac;
  return config;
});

axiosInstance.interceptors.response.use(
  response => {
    if (response.data.code === 0) {
      return response.data.data;
    }
    // Toast.fail(response.data.message);
    return Promise.reject(response.data);
  },
  error => {
    Toast.fail("服务异常, 请稍后再试");
    return Promise.reject(error);
  }
);

export default axiosInstance;
